<template>
  <v-chart class="chart" :option="option" autoresize />
</template>

<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';
import { ref, defineComponent, watch } from 'vue';

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

function getColorBasedOnValue(value) {
  if (value === 'A.') return '#0D2434'; // Dark Blue
  if (value === 'B.') return '#5488D8'; // Soft Blue
  if (value === 'C.') return '#FF9E40'; // Orange
  if (value === 'D.') return '#FF0000'; // Red
  if (value === 'E.') return '#8BC34A'; // Green
  if (value === 'F.') return '#9C27B0'; // Purple
  if (value === 'G.') return '#FFC107'; // Amber
  if (value === 'H.') return '#03A9F4'; // Light Blue
  if (value === 'I.') return '#E91E63'; // Pink
  if (value === 'J.') return '#795548'; // Brown
  return '#CBC5CA'; // Default Gray
}


export default defineComponent({
  name: '',
  components: {
    VChart,
  },
  props: {
    option: {
      type: Array,
      required: true,
    },
    question: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const chartOption = ref(null);

    const updateChartOption = () => {
      chartOption.value = {
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}%',
        },
        series: [
          {
            name: props.question,
            type: 'pie',
            radius: '80%',
            center: ['50%', '50%'],
            data: props.option
              .filter((opt) => opt.percentage > 0)
              .map((opt) => ({
                value: opt.percentage,
                name: `${opt.label} ${opt.val}`,
                itemStyle: {
                  color: getColorBasedOnValue(opt.label),
                },
              })),
            emphasis: {
              itemStyle: {
                shadowBlur: 0,
                shadowOffsetX: 0,
                shadowColor: 'transparent',
              },
              scale: false,
            },
          },
        ],
      };
    };

    watch(
      () => props.option,
      () => {
        updateChartOption();
      },
      { deep: true, immediate: true }
    );

    return { option: chartOption };
  },
});
</script>
